module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/jonny-e4ca8684796beb9645227d7386385dd5.jpg";